import React, { Component } from 'react';
import _ from 'lodash';
import FontAwesome from 'react-fontawesome';

class NavigationSide extends Component {

    constructor(props) {
        super(props);
        this.displayModuleIcon = this.displayModuleIcon.bind(this);
        this.prepareModules = this.prepareModules.bind(this);
    }

    displayModuleIcon(type) {
        let fAwesomeName;
        switch (type) {
            case "Story":
                fAwesomeName = 'newspaper-o';
                break;
            case "Stories":
                fAwesomeName = 'book';
                break;
            case "Donor List":
                fAwesomeName = 'user';
                break;
            case "User Input":
                fAwesomeName = 'commenting-o';
                break;
            case "Search":
                fAwesomeName = 'search';
                break;
            default:
                fAwesomeName = 'newspaper-o';
                break;
        }
        return <span style={{ display: 'inline-block', width: this.props.screen.r16_9.p10 * 0.5 }}><FontAwesome name={fAwesomeName} /></span>
    }

    prepareModules() {
        return (
            this.props.modules.map(function (row, i) {
                if (row.include_in_navigation && row.display_module_type!=="Attract Loop") {
                    return (
                        <div onMouseDown={() => this.props.navroute(i, row.display_module_type, "sidemenu", {})} className="phand" key={row.id}>
                            <span>{this.displayModuleIcon(row.display_module_type)} {row.name}</span>
                        </div>
                    )
                }
                return null;
            }, this)
        )
    }

    render() {
        let modules = this.prepareModules();

        return (
            <div style={{ color: 'black', height: '100vh', textAlign: 'vertical', fontSize: this.props.screen.r16_9.p10 * .325 }}>
                <div className="outerC">
                    <div className="middleC">
                        <div style={{ textAlign: 'left', display: 'inline-block', lineHeight: '2' }}>
                            <div>
                                <b>Menu</b>
                            </div>
                            {modules}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NavigationSide;



// WEBPACK FOOTER //
// ./src/Components/Navigation/NavigationSide.js